/* src/app/private/configrations/form-builder/form-builder.component.scss */
.form-builder-container {
  background:
    linear-gradient(
      135deg,
      #f5f7fa 0%,
      #e8eef5 100%);
  min-height: 100vh;
  padding: 1.5rem;
}
.form-builder-container .card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 2rem;
}
.form-builder-container .field-card {
  background:
    linear-gradient(
      135deg,
      #ffffff 0%,
      #f8fafc 100%);
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: grab;
  position: relative;
  overflow: hidden;
}
.form-builder-container .field-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background:
    linear-gradient(
      90deg,
      #3b82f6,
      #8b5cf6);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}
.form-builder-container .field-card:hover {
  transform: translateX(8px) translateY(-2px);
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.2);
  border-color: #3b82f6;
}
.form-builder-container .field-card:hover::before {
  transform: scaleX(1);
}
.form-builder-container .field-card:active {
  cursor: grabbing;
  transform: scale(0.98);
}
.form-builder-container .form-canvas {
  background:
    linear-gradient(
      135deg,
      #ffffff 0%,
      #f0f9ff 100%);
  border: 3px dashed #cbd5e1;
  border-radius: 16px;
  transition: all 0.3s ease;
  position: relative;
}
.form-builder-container .form-canvas::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 16px;
  background:
    radial-gradient(
      circle at 50% 50%,
      rgba(59, 130, 246, 0.05) 0%,
      transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.form-builder-container .form-canvas:hover {
  border-color: #3b82f6;
  background:
    linear-gradient(
      135deg,
      #ffffff 0%,
      #dbeafe 100%);
  box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.1);
}
.form-builder-container .form-canvas:hover::after {
  opacity: 1;
}
.form-builder-container .field-item {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  animation: slideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.3s ease;
  position: relative;
}
.form-builder-container .field-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background:
    linear-gradient(
      180deg,
      #3b82f6,
      #8b5cf6);
  border-radius: 12px 0 0 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.form-builder-container .field-item:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.15);
  transform: translateY(-2px);
}
.form-builder-container .field-item:hover::before {
  opacity: 1;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.form-builder-container .custom-chip {
  background:
    linear-gradient(
      135deg,
      #dbeafe 0%,
      #bfdbfe 100%);
  color: #1e40af;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(30, 64, 175, 0.1);
}
.form-builder-container .p-chip-success {
  background:
    linear-gradient(
      135deg,
      #dcfce7 0%,
      #bbf7d0 100%);
  color: #166534;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(22, 101, 52, 0.1);
}
.form-builder-container .p-chip-warning {
  background:
    linear-gradient(
      135deg,
      #fef3c7 0%,
      #fde68a 100%);
  color: #92400e;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(146, 64, 14, 0.1);
}
.form-builder-container .left-panel {
  background:
    linear-gradient(
      180deg,
      #f8fafc 0%,
      #f1f5f9 100%);
  border-right: 2px solid #e2e8f0;
}
.form-builder-container .left-panel h3 {
  color: #1e293b;
  font-weight: 700;
  padding-bottom: 0.75rem;
  border-bottom: 3px solid #3b82f6;
  margin-bottom: 1.5rem;
  background:
    linear-gradient(
      90deg,
      #3b82f6,
      #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.form-builder-container .center-panel {
  background:
    linear-gradient(
      135deg,
      #fafbfc 0%,
      #f5f8fa 100%);
}
.form-builder-container .center-panel h3 {
  color: #1e293b;
  font-weight: 700;
  padding-bottom: 0.75rem;
  border-bottom: 3px solid #3b82f6;
  margin-bottom: 1.5rem;
  background:
    linear-gradient(
      90deg,
      #3b82f6,
      #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.form-builder-dialog :host ::ng-deep .p-dialog {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}
.form-builder-dialog :host ::ng-deep .p-dialog-header {
  background:
    linear-gradient(
      135deg,
      #3b82f6 0%,
      #8b5cf6 100%);
  color: white;
  padding: 1.5rem 2rem;
  border-radius: 20px 20px 0 0;
}
.form-builder-dialog :host ::ng-deep .p-dialog-header .dialog-header {
  font-size: 1.5rem;
  font-weight: 700;
}
.form-builder-dialog :host ::ng-deep .p-dialog-content {
  padding: 0;
  overflow: hidden;
  background: #f8fafc;
}
.form-builder-dialog :host ::ng-deep .p-dialog-footer {
  background: white;
  border-top: 2px solid #e5e7eb;
  padding: 1.5rem 2rem;
}
.form-builder-dialog .form-builder-workspace .left-panel {
  background:
    linear-gradient(
      180deg,
      #f8fafc 0%,
      #f1f5f9 100%);
  border-right: 2px solid #e2e8f0;
}
.form-builder-dialog .form-builder-workspace .center-panel .form-canvas {
  min-height: 500px;
}
.badge-data-type {
  background:
    linear-gradient(
      135deg,
      #f3f4f6 0%,
      #e5e7eb 100%);
  color: #374151;
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-weight: 600;
}
.badge-required {
  background:
    linear-gradient(
      135deg,
      #fee2e2 0%,
      #fecaca 100%);
  color: #991b1b;
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-weight: 600;
}
.badge-system {
  background:
    linear-gradient(
      135deg,
      #e9d5ff 0%,
      #d8b4fe 100%);
  color: #6b21a8;
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-weight: 600;
}
.info-box {
  background:
    linear-gradient(
      135deg,
      #dbeafe 0%,
      #bfdbfe 100%);
  border-left: 4px solid #3b82f6;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}
.info-box.warning {
  background:
    linear-gradient(
      135deg,
      #fef3c7 0%,
      #fde68a 100%);
  border-left-color: #f59e0b;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.1);
}
.info-box.success {
  background:
    linear-gradient(
      135deg,
      #dcfce7 0%,
      #bbf7d0 100%);
  border-left-color: #10b981;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.1);
}
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.action-buttons button {
  transition: all 0.2s ease;
}
.action-buttons button:hover {
  transform: scale(1.1);
}
/*# sourceMappingURL=form-builder.component.css.map */
